






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@vuetifyx/common/DataContainer";
import moment from "moment";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
      item: null,
      importItems: [],
      insertDialogContainer: new DataContainer(),
    };
  },
  methods: {
    makeTableOptions(item) {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: `Cấu hình thị trường - ${item?.name || ""}`,
          urlEnabled: true,
          search: {},
          filters: {
            filters: {
              startTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày bắt đầu (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày bắt đầu (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              endTime: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kết thúc (>=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kết thúc (<=)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          displayFields: {
            description: {
              text: "Mô tả",
              sortable: true,
            },
            startTime: {
              text: "Ngày bắt đầu",
              sortable: true,
              options: { filter: "dateTime" },
            },
            endTime: {
              text: "Ngày kết thúc",
              sortable: true,
              options: { filter: "dateTime" },
            },
            estimatedReturnPercentage: {
              text: "% return dự kiến",
              sortable: true,
            },
            estimatedOtherMktCost: {
              text: "Chi phí MKT khác",
              sortable: true,
              options: { filter: "currency" },
            },
            estimatedOtherMktCostPercentage: {
              text: "% chi phí MKT khác",
              sortable: true,
            },
            estimatedProductGroupMktCostPercentage: {
              text: "% chi phí QC nhóm sản phẩm",
              sortable: true,
            },
            estimatedOperationCost: {
              text: "Chi phí vận hành tổng công ty",
              sortable: true,
              options: { filter: "currency" },
            },
            estimatedProductGroupOperationCostPercentage: {
              text: "% chi phí vận hành tổng công ty nhóm sản phẩm",
              sortable: true,
            },
            estimatedOrderOperationCost: {
              text: "Chi phí vận hành đơn hàng",
              sortable: true,
              options: { filter: "currency" },
            },
            estimatedOrderOperationCostPercentage: {
              text: "% chi phí vận hành đơn hàng",
              sortable: true,
            },
            estimatedSalaryPercentage: {
              text: "% lương",
              sortable: true,
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["admin"]) && {
              target: {
                dialog: {
                  attrs: {
                    width: "800px",
                  },
                  ext: {
                    subTitleMaker(item) {
                      return moment(item.startTime).format("DD/MM/YYYY") + " - " + moment(item.endTime).format("DD/MM/YYYY");
                    },
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["admin"]) && {
                target: {
                  dialog: {
                    attrs: {
                      width: "800px",
                    },
                    ext: {
                      subTitleMaker(item) {
                        return moment(item.startTime).format("DD/MM/YYYY") + " - " + moment(item.endTime).format("DD/MM/YYYY");
                      },
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "marketId",
              operator: "equal_to",
              value: this.context().$route.params.marketId,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("marketConfigItems", "findAll", options);
              return [items, count];
            },
            async insert(item, dataTable) {
              item.marketId = dataTable.context().$route.params.marketId;
              return await coreApiClient.call("marketConfigItems", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "marketConfigItems",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("marketConfigItems", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              startTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày bắt đầu",
                  required: true,
                },
              },
              endTime: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Ngày kết thúc",
                  required: true,
                },
              },
              estimatedReturnPercentage: {
                type: "number",
                attrs: {
                  label: "% return dự kiến",
                },
              },
              estimatedOtherMktCost: {
                type: "number",
                attrs: {
                  label: "Chi phí MKT khác",
                },
              },
              estimatedOtherMktCostPercentage: {
                type: "number",
                attrs: {
                  label: "% chi phí MKT khác",
                },
              },
              estimatedProductGroupMktCostPercentage: {
                type: "number",
                attrs: {
                  label: "% chi phí QC nhóm sản phẩm",
                },
              },
              estimatedOperationCost: {
                type: "number",
                attrs: {
                  label: "Chi phí vận hành tổng công ty",
                },
              },
              estimatedProductGroupOperationCostPercentage: {
                type: "number",
                attrs: {
                  label: "% chi phí vận hành nhóm sản phẩm",
                },
              },
              estimatedOrderOperationCost: {
                type: "number",
                attrs: {
                  label: "Chi phí vận hành đơn hàng / đơn",
                },
              },
              estimatedOrderOperationCostPercentage: {
                type: "number",
                attrs: {
                  label: "% chi phí vận hành đơn hàng",
                },
              },
              estimatedSalaryPercentage: {
                type: "number",
                attrs: {
                  label: "% lương",
                },
              },
            },
            insertForm: userManager.checkRole(["admin"]) && {
              content: {
                fieldNames: [
                  "startTime",
                  "endTime",
                  "estimatedReturnPercentage",
                  "estimatedOtherMktCost",
                  "estimatedOtherMktCostPercentage",
                  "estimatedProductGroupMktCostPercentage",
                  "estimatedOperationCost",
                  "estimatedProductGroupOperationCostPercentage",
                  "estimatedOrderOperationCost",
                  "estimatedOrderOperationCostPercentage",
                  "estimatedSalaryPercentage",
                  "description",
                ],
                colLength: 4,
              },
            },
            editForm: userManager.checkRole(["admin"]) && {
              content: {
                fieldNames: [
                  "startTime",
                  "endTime",
                  "estimatedReturnPercentage",
                  "estimatedOtherMktCost",
                  "estimatedOtherMktCostPercentage",
                  "estimatedProductGroupMktCostPercentage",
                  "estimatedOperationCost",
                  "estimatedProductGroupOperationCostPercentage",
                  "estimatedOrderOperationCost",
                  "estimatedOrderOperationCostPercentage",
                  "estimatedSalaryPercentage",
                  "description",
                ],
                colLength: 4,
              },
            },
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "description",
            },
          },
        },
      };
    },
  },
  async created() {
    this.item = await coreApiClient.call("markets", "findById", {
      id: this.$route.params.marketId,
    });
    this.tableOptions = this.makeTableOptions(this.item);
  },
});
